import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import TopNav from "../../Components/Dashboards/TopNav";
import Notifications from "../../Components/Dashboards/Notifications";
import NavHeader2 from "../../Components/Dashboards/NavHeader2";
import Sidebar from "../../Components/Dashboards/Sidebar";
import Footer from "../../Components/Dashboards/Footer";
import BreadcrumTop from "../../Components/Dashboards/BreadcrumTop";
import { useDeleteProduct } from "../../Components/Dashboards/../../hooks/useProducts";

export default function DeleteProduct(props) {
  const { isLoaded } = props;

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [productId, setProductId] = useState("");
  const [marketerId, setMarketerId] = useState("");
  const [companyId, setCompanyId] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state?.rowData;

  const deleteProductMutation = useDeleteProduct();

  useEffect(() => {
    document.title = "Delete Product | Dashboard";
  }, []);

  useEffect(() => {
    if (rowData) {
      setId(rowData.id || "");
      setName(rowData.name || "");
      setProductId(rowData.productId || "");
      setMarketerId(rowData.marketerId || "");
      setCompanyId(rowData.companyId || "");
    }
  }, [rowData]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    deleteProductMutation.mutate(id);
  };

  return (
    <>
      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body">
          <div className="container-fluid">
            <BreadcrumTop title="Delete Product" />

            <div className="row">
              <div className="col-xl-7 col-lg-10 col-md-10 mx-auto">
                <div className="card">
                  <div className="card-body">
                    <div className="basic-form">
                      <form onSubmit={handleSubmit}>
                        <div className="mb-2 row">
                          <div className="col-sm-10 offset-sm-2">
                            <div
                              className="alert alert-danger text-uppercase"
                              role="alert"
                            >
                              <b>Are you sure you want to delete this product?</b>
                            </div>
                          </div>
                        </div>

                        <input type="hidden" name="id" value={id} />

                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Product Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="name"
                              value={name}
                              readOnly
                              className="form-control"
                              placeholder="Product Name"
                            />
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Product ID
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="productId"
                              value={productId}
                              readOnly
                              className="form-control"
                              placeholder="Product ID"
                            />
                          </div>
                        </div>

                        <div className="mb-3 mt-4 row">
                          <div className="col-sm-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-danger m-1"
                              disabled={deleteProductMutation.isLoading}
                            >
                              {deleteProductMutation.isLoading ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "Delete Product"
                              )}
                            </button>
                            <Link to="/products" className="btn btn-dark m-1">
                              Go Back
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}